import { useDocumentEdit, InvoiceEditData, InvoiceEditItem } from './useDocumentEdit';
import { invoicesAPI } from '../utils/api';

// Ré-exporter les types pour compatibilité
export type { InvoiceEditData, InvoiceEditItem };

/**
 * Hook pour gérer l'édition d'une facture
 * Wrapper autour de useDocumentEdit pour la compatibilité
 *
 * @param initialData - Données initiales de la facture
 * @param vatRegime - Régime de TVA (optionnel)
 * @param onSuccess - Callback appelé après sauvegarde réussie avec l'ID de la facture
 * @param defaultTaxRate - Taux de TVA par défaut pour initialiser les nouveaux items
 */
export function useInvoiceEdit(
  initialData: InvoiceEditData,
  vatRegime?: string,
  onSuccess?: (invoiceId: string) => void,
  defaultTaxRate?: { id: string; rate: number }  // ✅ AJOUTÉ
) {
  const result = useDocumentEdit<InvoiceEditData>(
    {
      documentType: 'invoice',
      api: invoicesAPI,
      route: '/invoices',
      numberField: 'invoiceNumber',
      dateEndField: 'dueDate',
      successMessages: {
        created: 'Facture créée avec succès',
        updated: 'Facture mise à jour avec succès',
      },
    },
    initialData,
    vatRegime,
    onSuccess,
    defaultTaxRate  // ✅ AJOUTÉ: Passer defaultTaxRate au hook générique
  );

  // Retourner avec des noms compatibles
  return {
    invoiceData: result.documentData,
    isSaving: result.isSaving,
    hasChanges: result.hasChanges,
    updateField: result.updateField,
    updateDiscountType: result.updateDiscountType,
    updateDiscountValue: result.updateDiscountValue,
    updateItem: result.updateItem,
    addItem: result.addItem,
    removeItem: result.removeItem,
    addSectionTitle: result.addSectionTitle,
    addComment: result.addComment,
    addSubtotal: result.addSubtotal,
    addCompositeLines: result.addCompositeLines,
    addProductFromCatalog: result.addProductFromCatalog,
    saveInvoice: result.saveDocument,
  };
}
